import { useRef } from 'react';

export const useFocus = () => {
  const htmlElRef = useRef(null);
  const setFocus = (keepFocus = true) => {
    if (!htmlElRef?.current) {
      return;
    }

    if (keepFocus) {
      htmlElRef.current.focus();
    } else {
      htmlElRef.current.blur();
    }
  };
  return [htmlElRef, setFocus];
};
